import { memo } from "react";

import { CarouselArrow, CarouselArrows } from "@components/Carousel";
import { TRANSPARENT_CLASS } from "@components/Carousel/constants";
import { type TTailwindString, tw } from "classnames";

type Direction = "prev" | "next";

const styles = {
  wrapper: tw(
    "absolute",
    "bottom-0",
    "left-0",
    "right-0",
    "top-0",
    "hidden",
    "items-center",
    "justify-between",
    "p-3",
    "md:flex"
  ),
  button: (direction: Direction) =>
    tw(
      "shadow-md",
      TRANSPARENT_CLASS,
      "disabled:opacity-0" as TTailwindString,
      {
        [tw("disabled:-translate-x-1/4" as TTailwindString)]:
          direction === "prev",
        [tw("disabled:translate-x-1/4" as TTailwindString)]:
          direction === "next",
      }
    ),
};

const CartUpsellCarouselPaginationBase = () => {
  return (
    <CarouselArrows className={styles.wrapper}>
      <CarouselArrow
        className={tw(styles.button("prev"))}
        direction="prev"
        size="xs"
      />
      <CarouselArrow
        className={tw(styles.button("next"))}
        direction="next"
        size="xs"
      />
    </CarouselArrows>
  );
};

export const CartUpsellCarouselPagination = memo(
  CartUpsellCarouselPaginationBase
);
